// extracted by mini-css-extract-plugin
export default {"container":"RegistrationStatus_container__GVo8B","message":"RegistrationStatus_message__RJzZ9","suspended":"RegistrationStatus_suspended__lxInO"};